import { useInput } from '@pletly/ui';
import { formatUsername, getIsUsernameValid } from '@pletly/shared';
import { isMeetingRequirements } from '../components';

export const useRegisterFields = () => {
	const email = useInput('');
	const username = useInput('', formatUsername);
	const password = useInput('');
	const firstName = useInput('');
	const lastName = useInput('');

	const isEmailValid = email.value.includes('@');
	const isUsernameValid = getIsUsernameValid(username.value);
	const isPasswordValid = isMeetingRequirements(password.value);

	return {
		email,
		username,
		password,
		firstName,
		lastName,
		isEmailValid,
		isUsernameValid,
		isPasswordValid,
	};
};
